/* eslint-disable global-require */
/*
NOTICE: não utilize margin-top, utilize top
        classe especial delay, a animação leva 0.5 a mais para começar
*/
const sliders = [
   {
        "href": "/produtos/rany-boiadeira",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/rany-boiadeira/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/rany-boiadeira/logo.png").default,
                    classes: 'absolute z-20 top-16 ml-4 w-1/2 sm:w-2/5 lg:top-20 lg:ml-44 lg:w-72'
                },
                {
                    src: require("../images/slides/rany-boiadeira/box.png").default,
                    classes: 'absolute z-20 top-8 w-60 left-1/2 transform -translate-x-1/2 hidden lg:block lg:left-2/3 lg:top-32 xl:top-44 xl:left-1/2'
                },
                {
                    src: require("../images/slides/rany-boiadeira/product1.png").default,
                    classes: 'absolute z-20 bottom-0 right-4 w-1/2 sm:w-2/5 lg:right-auto lg:left-1/2 lg:ml-40 lg:w-96 fade-in'
                },
                {
                    src: require("../images/slides/rany-boiadeira/splash.png").default,
                    classes: 'absolute z-20 top-72 left-0 ml-52 bottom-0 delay hidden md:w-auto lg:block'
                },
            ]
    },
    {
        "href": "/produtos/cecy-frases",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/cecy-frases/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/cecy-frases/logo.png").default,
                    classes: 'absolute z-20 top-16 ml-4 w-1/2 sm:w-2/5 lg:ml-36 lg:w-auto'
                },
                {
                    src: require("../images/slides/cecy-frases/box.png").default,
                    classes: 'absolute z-20 top-8  w-72 left-1/2 transform -translate-x-1/2 -ml-24 fade-in hidden lg:block lg:left-2/3 lg:top-24 xl:left-1/2'
                },
                {
                    src: require("../images/slides/cecy-frases/splash-1.png").default,
                    classes: 'absolute z-20 top-60 left-0 ml-40 bottom-0 delay hidden md:w-auto lg:block'
                },
                                {
                    src: require("../images/slides/cecy-frases/splash-2.png").default,
                    classes: 'absolute z-20 bottom-0 p-2 right-0 mr-44 top-20 fade-in hidden xl:block'
                },
                {
                    src: require("../images/slides/cecy-frases/product1.png").default,
                    classes: 'absolute z-20 bottom-0 right-4 w-1/2 sm:w-2/5 lg:left-1/6 lg:ml-4 lg:w-96 xl:left-1/2 xl:right-auto'
                },
            ]
    },
    {
        "href": "/produtos/cecy-cantiga",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/cecy-cantiga/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/cecy-cantiga/logo.png").default,
                    classes: 'absolute z-20 top-16 ml-4 w-1/2 sm:w-2/5 lg:ml-44 lg:w-60 fade-in'
                },
                {
                    src: require("../images/slides/cecy-cantiga/box.png").default,
                    classes: 'absolute z-20 top-8 w-72 left-1/2 transform -translate-x-1/2 -ml-24 fade-in hidden lg:block lg:top-32 lg:left-2/3 xl:left-1/2'
                },
                {
                    src: require("../images/slides/cecy-cantiga/splash-1.png").default,
                    classes: 'absolute z-20 bottom-0 p-2 left-96 pl-12 top-60 w-48 fade-in hidden xl:block'
                },
                {
                    src: require("../images/slides/cecy-cantiga/splash-2.png").default,
                    classes: 'absolute z-20 top-12 w-40 left-1/3 pr-6 fade-in hidden xl:block'
                },
                {
                    src: require("../images/slides/cecy-cantiga/splash-3.png").default,
                    classes: 'absolute z-20 bottom-0 p-2 right-0 mr-40 top-32 fade-in hidden xl:block'
                },
                {
                    src: require("../images/slides/cecy-cantiga/product1.png").default,
                    classes: 'absolute z-20 bottom-0 right-4 w-1/2 sm:w-2/5 lg:right-0 xl:left-1/2 lg:ml-4 lg:w-96'
                }
            ]
    },
    {
        "href": "/produtos/colorita",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/colorita/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/colorita/logo.png").default,
                    classes: 'absolute z-20 top-16 ml-4 w-1/2 sm:w-1/3 lg:w-1/5 lg:transform lg:-translate-x-1/2 lg:top-20 xl:top-16 xl:w-1/6 lg:left-1/3 xl:left-1/2 fade-in'
                },
                {
                    src: require("../images/slides/colorita/box.png").default,
                    classes: 'absolute z-20 top-60 w-60 right-0 mr-96 pr-16 fade-in hidden lg:block'
                },
                {
                    src: require("../images/slides/colorita/splash.png").default,
                    classes: 'absolute z-20 top-52 w-1/4 ml-36 left-1/3 transform -translate-x-1/2 fade-in hidden xl:block'
                },
                {
                    src: require("../images/slides/colorita/product1.png").default,
                    classes: 'absolute z-20 bottom-0 right-4 w-1/3 sm:w-1/4 lg:bottom-2 lg:right-60 lg:w-48 fade-in'
                }
            ]
    },
        {
        "href": "/produtos/luly-carinho",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/luly-carinho/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/luly-carinho/logo.png").default,
                    classes: 'absolute z-20 top-16 ml-4 w-2/5 sm:w-1/3 lg:top-24 lg:ml-52 lg:w-60 fade-in '
                },
                {
                    src: require("../images/slides/luly-carinho/box.png").default,
                    classes: 'absolute z-20 top-4 w-72 left-1/2 transform -translate-x-1/2 fade-in hidden lg:block lg:top-48 lg:left-1/3 xl:left-1/2 xl:top-4'
                },
                {
                    src: require("../images/slides/luly-carinho/splash.png").default,
                    classes: 'absolute z-20 top-60 w-96 ml-60 fade-in hidden xl:block'
                },
                {
                    src: require("../images/slides/luly-carinho/product1.png").default,
                    classes: 'absolute z-20 bottom-12 right-4 w-1/2 sm:w-2/5 lg:right-0 lg:bottom-0 lg:w-2/5'
                }
            ]
    },
        {
        "href": "/produtos/dily-summer-glow",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/dily-summer-glow/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/dily-summer-glow/logo.png").default,
                    classes: 'absolute z-20 top-16 ml-4 w-2/5 sm:w-1/3 lg:top-24 lg:ml-48 lg:w-auto fade-in '
                },
                {
                    src: require("../images/slides/dily-summer-glow/box.png").default,
                    classes: 'absolute z-20 top-1/3 w-60 left-1/2 transform -translate-x-1/2 fade-in hidden lg:block lg:top-48 xl:top-1/3'
                },
                {
                    src: require("../images/slides/dily-summer-glow/splash.png").default,
                    classes: 'absolute z-20 top-64 ml-48 w-60 fade-in hidden lg:block'
                },
                {
                    src: require("../images/slides/dily-summer-glow/product1.png").default,
                    classes: 'absolute z-20 bottom-0 right-4 w-1/3 sm:w-1/4 lg:right-48 lg:w-1/5 xl:right-72 xl:w-1/6 fade-in'
                }
            ]
    }

    /** OLD sliders for reference*/
    /*

    {
        "href": "/produtos/capy-toy",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/capy-toy/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/capy-toy/logo.png").default,
                    classes: 'absolute z-20 top-8 xl:top-36 ml-5 xl:ml-48 w-44 sm:w-48 xl:w-auto'
                },
                {
                    src: require("../images/slides/capy-toy/product1.png").default,
                    classes: 'absolute z-20 bottom-0 p-5 left-1/2 transform -translate-x-1/2 w-64 md:w-2/5 lg:w-80'
                },
                {
                    src: require("../images/slides/capy-toy/splash.png").default,
                    classes: 'absolute z-20 top-24 right-0 bottom-0 lg:mr-48 xl:ml-1/5 delay hidden xl:block md:w-auto'
                },
            ]
    },
    {
        "href": "/produtos/mister-bublly",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/mister-bublly/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/mister-bublly/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-44 w-44 sm:w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/mister-bublly/splash.png").default,
                    classes: 'absolute z-20 top-32 delay hidden lg:left-64 xl:block md:w-auto left-1/2 transform -translate-x-1/2'
                },
                {
                    src: require("../images/slides/mister-bublly/product1.png").default,
                    classes: 'absolute z-20 right-0  bottom-4 w-4/5 sm:w-3/5 lg:w-2/5'
                },
            ]
    },
    {
        "href": "/produtos/madu",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/madu/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/madu/logo.png").default,
                    classes: 'absolute z-20 top-8 ml-5 lg:ml-40 w-40 sm:w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/madu/splash.png").default,
                    classes: 'absolute z-20 top-52 lg:ml-16 xl:ml-78 delay hidden lg:block md:w-auto'
                },
                {
                    src: require("../images/slides/madu/product1.png").default,
                    classes: 'absolute z-20 right-0 lg:right-40 bottom-4 w-62 lg:w-2/5 md:w-3/5 sm:w-3/5'
                }
            ]
    },
    {
        "href": "/produtos/dinossauros-adventure-pintura",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/dinossauros-adventure-pintura/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/dinossauros-adventure-pintura/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-44 lg:w-52 sm:w-60 xl:w-72'
                },
                {
                    src: require("../images/slides/dinossauros-adventure-pintura/splash.png").default,
                    classes: 'absolute z-20 top-72 lg:ml-16 xl:ml-56 delay hidden lg:block md:w-auto'
                },
                {
                    src: require("../images/slides/dinossauros-adventure-pintura/product1.png").default,
                    classes: 'absolute z-20 right-0 lg:right-64 bottom-4 w-52 lg:w-2/5 md: w-4/5 sm:w-3/5'
                }
            ]
    },

    {
        "href": "/produtos/chef-lis",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/chef-lis/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/chef-lis/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-44 sm:w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/chef-lis/splash.png").default,
                    classes: 'absolute z-20 top-72 lg:ml-16 xl:ml-1/5 delay hidden lg:block md:w-auto'
                },
                {
                    src: require("../images/slides/chef-lis/splash2.png").default,
                    classes: 'absolute z-20 top-72 delay hidden xl:block md:w-auto left-1/2 transform -translate-x-1/2'
                },
                {
                    src: require("../images/slides/chef-lis/product1.png").default,
                    classes: 'absolute z-20 right-0 lg:right-32 bottom-4'
                }
            ]
    },
    {
        "href": "/produtos/lovie-dog-pintura",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/lovie-dog/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/lovie-dog/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-44 sm:w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/lovie-dog/splash.png").default,
                    classes: 'absolute z-20 top-72 delay hidden xl:block md:w-auto left-1/2 transform -translate-x-1/2'
                },
                {
                    src: require("../images/slides/lovie-dog/splash2.png").default,
                    classes: 'absolute z-20 top-72 ml-32 delay hidden xl:block md:w-auto'
                },
                {
                    src: require("../images/slides/lovie-dog/product1.png").default,
                    classes: 'absolute z-20 right-0 lg:right-96 bottom-8 w-52'
                }
            ]
    },
    {
        "href": "/produtos/lala-peniquinho",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/lala-peniquinho/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/lala-peniquinho/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-44 sm:w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/lala-peniquinho/splash.png").default,
                    classes: 'absolute z-20 top-72 lg:ml-16 xl:ml-96 delay hidden lg:block md:w-auto'
                },
                {
                    src: require("../images/slides/lala-peniquinho/splash2.png").default,
                    classes: 'absolute z-20 top-72 ml-32 delay hidden xl:block w-60'
                },
                {
                    src: require("../images/slides/lala-peniquinho/product1.png").default,
                    classes: 'absolute z-20 right-0 lg:right-96 bottom-8 w-52 lg:w-1/5'
                }
            ]
    },
    {
        "href": "/produtos/baby-dodoi",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/baby-dodoi/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/baby-dodoi/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-44 lg:w-52 sm:w-60 xl:w-72'
                },
                {
                    src: require("../images/slides/baby-dodoi/splash.png").default,
                    classes: 'absolute z-20 top-72 lg:ml-16 xl:ml-96 delay hidden lg:block md:w-auto'
                },
                {
                    src: require("../images/slides/baby-dodoi/splash2.png").default,
                    classes: 'absolute z-20 top-72 ml-32 delay hidden xl:block w-60'
                },
                {
                    src: require("../images/slides/baby-dodoi/product1.png").default,
                    classes: 'absolute z-20 right-0 lg:right-96 bottom-4 w-52 lg:w-1/5'
                }
            ]
    },


    {
        "href": "/produtos/my-uni",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/old/my-uni/bg.jpg").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/old/my-uni/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-44 sm:w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/old/my-uni/splash.png").default,
                    classes: 'absolute z-20 top-72 lg:ml-16 xl:ml-96 delay hidden lg:block md:w-auto'
                },
                {
                    src: require("../images/slides/old/my-uni/splash2.png").default,
                    classes: 'absolute z-20 top-72 ml-32 delay hidden xl:block md:w-auto'
                },
                {
                    src: require("../images/slides/old/my-uni/product1.png").default,
                    classes: 'absolute z-20 right-0 lg:right-96 bottom-8 w-52 lg:w-1/5'
                }
            ]
    },
    {
        "href": "/produtos/lovie-dogs",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/old/lovie-dogs/bg.png").default,
                    classes: 'absolute object-cover object-bottom h-full w-full z-0'
                },
                {
                    src: require("../images/slides/old/lovie-dogs/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/old/lovie-dogs/splash.png").default,
                    classes: 'absolute z-20 bottom-4 lg:ml-16 xl:ml-96 delay hidden md:block md:w-auto'
                },
                {
                    src: require("../images/slides/old/my-uni/splash2.png").default,
                    classes: 'absolute z-20 top-72 ml-32 delay hidden xl:block md:w-auto'
                },
                {
                    src: require("../images/slides/old/lovie-dogs/product1.png").default,
                    classes: 'w-96 absolute z-20 right-96 bottom-4 hidden lg:block md:w-80'
                },
                {
                    src: require("../images/slides/old/lovie-dogs/product2.png").default,
                    classes: 'w-96 absolute z-20 right-40 bottom-4 hidden md:block md:w-80'
                },
                {
                    src: require("../images/slides/old/lovie-dogs/product3.png").default,
                    classes: 'w-96 absolute z-20 right-0 bottom-5 md:block md:w-80'
                },
            ]
    },
    {
        "href": "/produtos/dino-history-explorer-dedoches",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/old/dino-history-explorer-dedoches/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/old/dino-history-explorer-dedoches/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-44 sm:w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/old/dino-history-explorer-dedoches/splash.png").default,
                    classes: 'absolute z-20 top-72 lg:ml-16 xl:ml-96 delay hidden lg:block md:w-auto'
                },
                {
                    src: require("../images/slides/old/dino-history-explorer-dedoches/product1.png").default,
                    classes: 'absolute z-20 right-0 bottom-8 lg:bottom-32'
                },
                {
                    src: require("../images/slides/old/dino-history-explorer-dedoches/product2.png").default,
                    classes: 'absolute z-20 right-0 lg:right-96 bottom-8 w-52 lg:w-1/5 hidden lg:block'
                }
            ]
    },
    {
        "href": "/produtos/dino-history-species-dedoches",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/old/dino-history-species-dedoches/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/old/dino-history-species-dedoches/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-44 sm:w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/old/dino-history-species-dedoches/splash.png").default,
                    classes: 'absolute z-20 top-72 lg:ml-16 xl:ml-96 delay hidden lg:block md:w-auto'
                },
                {
                    src: require("../images/slides/old/dino-history-species-dedoches/product1.png").default,
                    classes: 'absolute z-20 right-0 w-72 md:w-auto bottom-0'
                },
                {
                    src: require("../images/slides/old/dino-history-species-dedoches/product2.png").default,
                    classes: 'absolute z-20 right-0 lg:right-96 bottom-8 w-52 lg:w-1/5 hidden lg:block'
                }
            ]
    },
    {
        "href": "/produtos/lizzy",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/old/lizzy/bg.png").default,
                    classes: 'absolute object-cover object-bottom h-full w-full z-0'
                },
                {
                    src: require("../images/slides/old/lizzy/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-44 sm:w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/old/lizzy/splash.png").default,
                    classes: 'absolute z-20 top-72 lg:ml-16 xl:ml-96 delay hidden lg:block md:w-auto'
                },
                {
                    src: require("../images/slides/old/lizzy/product1.png").default,
                    classes: 'absolute z-20 right-0 lg:right-96 bottom-0 w-auto'
                }
            ]
    },
    {
        "href": "/produtos/love-babie-aninha",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/old/love-babie-aninha/bg.png").default,
                    classes: 'absolute object-cover object-bottom h-full w-full z-0'
                },
                {
                    src: require("../images/slides/old/love-babie-aninha/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-5 lg:ml-48 w-44 sm:w-60 xl:w-auto'
                },
                {
                    src: require("../images/slides/old/love-babie-aninha/splash.png").default,
                    classes: 'absolute z-20 top-72 lg:ml-16 xl:ml-96 delay hidden lg:block md:w-auto'
                },
                {
                    src: require("../images/slides/old/love-babie-aninha/product1.png").default,
                    classes: 'absolute z-20 right-0 lg:right-96 bottom-4 w-52 lg:w-1/6'
                }
            ]
    },
    {
        "href": "/produtos/love-babie-banheirinha",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/old/love-babie-banheirinha/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/old/love-babie-banheirinha/logo.png").default,
                    classes: 'absolute z-20 top-12 ml-48 lg:w-44 xl:w-auto'
                },
                {
                    src: require("../images/slides/old/love-babie-banheirinha/splash.png").default,
                    classes: 'absolute z-20 top-64 ml-24 delay hidden md:block md:w-64 xl:w-auto'
                },
                {
                    src: require("../images/slides/old/love-babie-banheirinha/product1.png").default,
                    classes: 'absolute z-20 right-10 bottom-8 w-52 lg:w-auto'
                },
                {
                    src: require("../images/slides/old/love-babie-banheirinha/product2.png").default,
                    classes: 'absolute z-20 right-10 bottom-4 mr-44 lg:mr-72 w-32 lg:w-auto'
                }
            ]
    },
    {
        "href": "/produtos/dinossauros-adventure",
        "target": "_self",
        "images":
            [
                {
                    src: require("../images/slides/old/dinossauros-adventure/bg.png").default,
                    classes: 'absolute object-cover h-full w-full z-0'
                },
                {
                    src: require("../images/slides/old/dinossauros-adventure/logo.png").default,
                    classes: 'absolute z-20 top-4 left-0 right-0 ml-auto mr-auto'
                },
                {
                    src: require("../images/slides/old/dinossauros-adventure/product2.png").default,
                    classes: 'w-96 absolute z-20 right-10 bottom-8 hidden md:block md:w-80'
                },
                {
                    src: require("../images/slides/old/dinossauros-adventure/product1.png").default,
                    classes: 'w-96 absolute z-20 left-0 right-0 ml-auto mr-auto bottom-8 md:hidden xl:block'
                },
                {
                    src: require("../images/slides/old/dinossauros-adventure/product3.png").default,
                    classes: 'w-96 absolute z-20 left-10 bottom-8 hidden md:block md:w-80'
                },
            ]
    }*/
];

export default sliders
